import React from "react";
import { Control, ControlProps } from 'react-redux-form';
import { NumberStepper, NumberStepperProps } from "..";

interface Props extends Omit<NumberStepperProps, "id" | "onChange" | "value"> {
  id?: string;
  model: string;
  onChange?: ControlProps<HTMLInputElement>["onChange"];
}

/**
 * RRF wrapper for NumberStepper
 */
export const RRFNumberStepper = (props: Props) => {
  return (
    <Control.text
      {...props}
      // NB don't write Control components inline, component boundary means React doesn't force a rerender
      component={NumberStepper}
      id={props.id ?? props.model}
    />
  );
}
